<template lang="pug">
#modal-visualizacao-auto
    .linha
        b.coluna Auto de infração {{ autoInfracao.numeroAutoInfracao }}
    .linha
        .coluna
            collapse-component(title='Dados do auto de infração', :isBasic='true')
                .linha
                    .coluna
                        span Orgão responsável pela autuação: {{ autoInfracao.orgaoAutuacao }}
                .linha
                    .coluna
                        span N do processo do auto de infração: {{ autoInfracao.numeroProcessoAutoInfracao }}
                .linha
                    .coluna
                        span N do auto de infração: {{ autoInfracao.numeroAutoInfracao }}
                .linha
                    .coluna
                        span Data da autuação: {{ autoInfracao.dataAutuacao | data  }}
                .linha
                    .coluna
                        span Data do comentido da infração: {{ autoInfracao.dataCometimento | data  }}

    .linha
        .coluna
            collapse-component(title='Dados do embargo', :isBasic='true')
                .linha
                    .coluna
                        span N do termo de embargo: {{ autoInfracao.numeroTermoEmbargo }}
                .linha
                    .coluna
                        span Data do embargo: {{ autoInfracao.dataEmbargo | data  }}
                .linha(v-if='autoInfracao.numeroSerieEmbargo')
                    .coluna
                        span N de série: {{ autoInfracao.numeroSerieEmbargo }}
    .linha
        .coluna
            collapse-component(title='Detalhes do auto de infração ou embargo', :isBasic='true')
                .linha
                    .coluna
                        span Infração: {{ autoInfracao.infracao }}
                .linha
                    .coluna
                        span Quantificação do objeto de infração: {{ autoInfracao.quantificacaoInfracao }}
                .linha
                    .coluna
                        span Unidade: {{ autoInfracao.unidade }}
                .linha
                    .coluna
                        span Descrição da infração e/ou motivo do embargo: {{ autoInfracao.descricao }}
    //- .linha
    //-     .coluna
    //-         collapse-component(title='Localizaçãos dos auto(s) de infração/embargo(s) do imóvel', :isBasic='true')


</template>

<script>

export default {

    name: 'ModalVisualizacaoSancoes',

    props: {
        autoInfracao: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
        };
    },

    methods: {
    }
}
</script>

<style scoped>
#modal-visualizacao-auto {
    width: 500px;
    max-height: 500px;
    word-break: break-all;

    overflow-y: auto;
}

#modal-visualizacao-auto::-webkit-scrollbar {
    width: 8px;
}

#modal-visualizacao-auto::-webkit-scrollbar-track {
    background-color: var(--primary-smoke);
}

#modal-visualizacao-auto::-webkit-scrollbar-thumb {
    border-radius: 100px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
</style>
